<div class="min-h-screen bg-surface">
  @if (toastMessage()) {
    <div class="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 animate-fade-in">
      <div class="flex items-center gap-3 rounded-xl bg-slate-900 px-5 py-3 text-sm font-medium text-white shadow-xl">
        <svg class="h-4 w-4 shrink-0 text-amber-400" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
        {{ toastMessage() }}
      </div>
    </div>
  }

  <p-dialog
    header="提示"
    [visible]="showSubscriptionDialog()"
    [modal]="true"
    [closable]="true"
    [style]="{ width: '22rem' }"
    [breakpoints]="{ '575px': '90vw' }"
    (onHide)="closeSubscriptionDialog()"
    [pt]="{
      root: { class: 'rounded-xl border border-slate-200 bg-white shadow-card' },
      header: { class: 'flex items-center justify-between gap-4 border-b border-slate-200 px-6 py-4' },
      title: { class: 'font-display text-lg font-semibold text-slate-900' },
      headerActions: { class: 'ml-auto shrink-0' },
      content: { class: 'p-6' },
      mask: { class: 'bg-slate-900/40 backdrop-blur-sm' }
    }"
  >
    <p class="text-slate-700">请订阅后继续练习</p>
    <ng-template pTemplate="footer">
      <div class="flex justify-end gap-3">
        <p-button
          label="取消"
          severity="secondary"
          (onClick)="closeSubscriptionDialog()"
          [pt]="{ root: { class: 'rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50' } }"
        />
        <p-button
          label="确定"
          (onClick)="onSubscriptionDialogOk()"
          [pt]="{ root: { class: 'rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-500' } }"
        />
      </div>
    </ng-template>
  </p-dialog>

  <div class="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8">
    <a
      [routerLink]="['/writing/topics']"
      class="mb-6 inline-flex items-center gap-2 text-sm font-medium text-slate-600 transition-colors hover:text-slate-900"
    >
      <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
      </svg>
      返回选择年月
    </a>

    @if (combinations().length) {
      @for (c of combinations(); track c.id) {
        <div class="mb-8 flex flex-wrap items-center justify-between gap-4">
          <div>
            <h1 class="font-display text-2xl font-bold text-slate-900">Combination {{ c.combinationNumber }}</h1>
          </div>
          <button
            type="button"
            (click)="startPractice(c)"
            [disabled]="practiceLoading()"
            class="inline-flex shrink-0 items-center gap-2 rounded-full bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white shadow-md transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
          >
            @if (practiceLoading()) {
              <svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
            } @else {
              <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />
              </svg>
            }
            开始练习
          </button>
        </div>

        <div class="space-y-8 mb-12">
          <!-- Tâche 1 -->
          <article class="rounded-xl border border-slate-200 bg-white p-6 shadow-card">
            <h2 class="font-display text-lg font-semibold text-slate-900">Tâche 1</h2>
            <p class="mt-4 leading-relaxed text-slate-700">{{ c.tache1.prompt }}</p>
          </article>

          <!-- Tâche 2 -->
          <article class="rounded-xl border border-slate-200 bg-white p-6 shadow-card">
            <h2 class="font-display text-lg font-semibold text-slate-900">Tâche 2</h2>
            <p class="mt-4 leading-relaxed text-slate-700">{{ c.tache2.prompt }}</p>
          </article>

          <!-- Tâche 3 -->
          <article class="rounded-xl border border-slate-200 bg-white p-6 shadow-card">
            <h2 class="font-display text-lg font-semibold text-slate-900">Tâche 3</h2>
            <p class="mt-2 font-medium text-slate-800">{{ c.tache3.prompt }}</p>

            @if (c.tache3.document1) {
              <div class="mt-4">
                <h3 class="text-sm font-semibold text-slate-700">Document 1 :</h3>
                <p class="mt-2 leading-relaxed text-slate-600">{{ c.tache3.document1 }}</p>
              </div>
            }

            @if (c.tache3.document2) {
              <div class="mt-4">
                <h3 class="text-sm font-semibold text-slate-700">Document 2 :</h3>
                <p class="mt-2 leading-relaxed text-slate-600">{{ c.tache3.document2 }}</p>
              </div>
            }
          </article>
        </div>
      }
    } @else if (loading()) {
      <p class="rounded-xl border border-slate-200 bg-white p-8 text-center text-slate-500">加载中...</p>
    } @else if (outOfRange()) {
      <p class="rounded-xl border border-amber-200 bg-amber-50 p-8 text-center text-amber-700">
        该月份的题目不可用，将在 2 秒后返回题库...
      </p>
    } @else {
      <p class="rounded-xl border border-slate-200 bg-white p-8 text-center text-slate-500">未找到该组合</p>
    }
  </div>
</div>
